import React from 'react';

import Typography from '@gogame/ui/Typography';

const ErrorText = ({ children }) => {
  return (
    <Typography color={'error'} variant={'caption'}>
      {children}
    </Typography>
  );
};

export default ErrorText;
